import _ from 'lodash';

const ReadingsHelpers = (function () {
  const depths = {
    0: '6"',
    1: '18"',
    2: '36"',
  };
  // For property curve: 0 = Red Low, 1 = Red Low and High, 2 = Red High
  const readings = {
    // V2 ones here
    batt_scaled: {
      name: 'mV',
      basePath: 'readings',
      path: 'battery',
      units: 'mV',
      precision: 1,
      order: 11,
      curve: 1,
      minVal: 3,
      conversion(m) {
        return (m * 1500) / 254 + 2500;
      },
      maxVal: 10,
    },
    pH: {
      name: 'pH',
      basePath: 'readings',
      path: 'ph',
      precision: 1,
      order: 11,
      curve: 1,
      minVal: 0,
      maxVal: 14,
    },
    ec: {
      name: 'ec',
      basePath: 'readings',
      path: 'ec',
      precision: 2,
      order: 11,
      units: ' mS/cm',
      curve: 1,
      minVal: 0,
      maxVal: 1000,
    },
    co2ppm: {
      name: 'CO₂',
      depths: [0],
      basePath: 'readings',
      path: 'co2',
      precision: 0,
      order: 11,
      curve: 1,
      minVal: 300,
      maxVal: 25000,
    },
    SOC: {
      name: 'SOC',
      depths: [0],
      basePath: 'readings',
      path: 'SOC',
      units: '%',
      precision: 2,
      order: 11,
      curve: 1,
      minVal: 0,
      maxVal: 12,
    },
    co2: {
      name: 'CO₂',
      depths: [0],
      basePath: 'readings',
      path: 'co2',
      units: 'ppm',
      precision: 0,
      order: 11,
      curve: 1,
      minVal: 0,
      maxVal: 1000,
    },
    o2: {
      name: 'O₂"',
      depths: [1],
      basePath: 'readings',
      path: 'o2',
      units: '%',
      precision: 2,
      order: 12,
      curve: 1,
      minVal: 0,
      maxVal: 100,
    },
    o2o2: {
      name: 'O₂',
      depths: [1],
      basePath: 'readings',
      path: 'o2',
      units: '%',
      precision: 2,
      order: 12,
      curve: 1,
      minVal: 0,
      maxVal: 25,
    },
    moisture: {
      name: 'Moisture',
      basePath: 'readings',
      path: 'moisture',
      units: '%',
      convert_units: '%',
      precision: 1,
      order: 9,
      curve: 0,
      conversion(m) {
        return m * 100;
      },
      minVal: 0,
      maxVal: 1.0,
    },
    lux_abs: {
      name: 'Lux',
      basePath: 'readings',
      path: 'lux_abs',
      units: '',
      precision: 2,
      order: 9,
      curve: 0,
    },
    air_temp: {
      name: 'Air Temp.',
      basePath: 'microclimate',
      path: 'temperature',
      precision: 1,
      conversion(tempC) {
        return tempC * 1.8 + 32;
      },
      unconvert(tempF) {
        return (tempF - 32) * (5 / 9);
      },
      units: '°C',
      convert_units: '°F',
      order: 16,
      curve: 1,
      minVal: 0,
      maxVal: 40,
    },
    air: {
      name: 'Air Temp.',
      basePath: 'microclimate',
      path: 'temperature',
      precision: 1,
      conversion(tempC) {
        return tempC * 1.8 + 32;
      },
      unconvert(tempF) {
        return (tempF - 32) * (5 / 9);
      },
      units: '°C',
      convert_units: '°F',
      order: 16,
      curve: 1,
      minVal: 0,
      maxVal: 40,
    },
    humidity: {
      name: 'Humidity',
      basePath: 'microclimate',
      path: 'humidity',
      precision: 1,
      units: '%',
      convert_units: '%',
      order: 13,
      curve: 2,
      minVal: 0,
      maxVal: 100,
      conversion(m) {
        return m * 100;
      },
    },
    soil_temp: {
      name: 'Soil Temp.',
      basePath: 'raw',
      path: 'temperature',
      precision: 1,
      conversion(tempC) {
        return tempC * 1.8 + 32;
      },
      unconvert(tempF) {
        return (tempF - 32) * (5 / 9);
      },
      units: '°C',
      convert_units: '°F',
      order: 10,
      curve: 1,
      minVal: 0,
      maxVal: 30,
    },
    socd: {
      name: 'SOC',
      basePath: 'raw',
      path: 'temperature',
      precision: 2,
      units: '%',
      order: 10,
      curve: 1,
      minVal: 0,
      maxVal: 30,
    },
    soil: {
      name: 'Soil Temp.',
      basePath: 'raw',
      path: 'temperature',
      precision: 1,
      conversion(tempC) {
        return tempC * 1.8 + 32;
      },
      unconvert(tempF) {
        return (tempF - 32) * (5 / 9);
      },
      units: '°C',
      convert_units: '°F',
      order: 10,
      curve: 1,
      minVal: 0,
      maxVal: 30,
    },
    n: {
      name: 'NO₃',
      depths: [0, 1, 2],
      basePath: 'readings',
      path: 'nitrogen_ppm',
      units: ' kg/ha',
      convert_units: 'lb/ac',
      precision: 0,
      order: 2,
      curve: 1,
      minVal: 0,
      maxVal: 40,
      conversion(kg) {
        return kg / 1.12;
      },
      unconvert(lb) {
        return lb * 1.12;
      },
    },
    p: {
      name: 'P',
      depths: [0, 1, 2],
      basePath: 'readings',
      path: 'phosphorus_ppm',
      units: ' kg/ha',
      convert_units: 'lb/ac',
      precision: 0,
      order: 2,
      curve: 1,
      minVal: 0,
      maxVal: 40,
      conversion(kg) {
        return kg / 1.12;
      },
      unconvert(lb) {
        return lb * 1.12;
      },
    },
    k: {
      name: 'K',
      depths: [0, 1, 2],
      basePath: 'readings',
      path: 'potassium_ppm',
      units: ' kg/ha',
      convert_units: 'lb/ac',
      precision: 0,
      order: 2,
      curve: 1,
      minVal: 0,
      maxVal: 40,
      conversion(kg) {
        return kg / 1.12;
      },
      unconvert(lb) {
        return lb * 1.12;
      },
    },
  };

  const ReadingStatus = {
    NORMAL: 0,
    NORMAL_LOW: 1,
    NORMAL_HIGH: 2,
    WARNING_LOW: 3,
    WARNING_HIGH: 4,
    CRITICAL_LOW: 5,
    CRITICAL_HIGH: 6,
    ERROR: 7,
  };

  // const ReadingDirection = {
  //   STABLE: 0,
  //   RISING: 1,
  //   RISING_FAST: 2,
  //   FALLING: 3,
  //   FALLING_FAST: 4,
  // };

  // const ReadingDirectionStrings = ['stable', 'rising', 'risingfast', 'falling', 'fallingfast'];

  const ReadingStatusStrings = {
    Normal: 'normal',
    LowNormal: 'lowNormal',
    HighNormal: 'highNormal',
    LowWarn: 'lowWarn',
    HighWarn: 'highWarn',
    LowCrit: 'lowCritical',
    HighCrit: 'highCritical',
    Error: 'error',
  };

  const getReadingDomain = (readingName) => {
    const noDepthName = getReadingName(readingName);
    if (_.has(readings, noDepthName)) {
      return [readings[noDepthName].minVal, readings[noDepthName].maxVal];
    }
    return [0, 'auto'];
  };

  const getReadingName = (readingName) => {
    let reading = readingName[0];
    const splitReading = reading.split('_');
    if (splitReading.length > 0 && splitReading.length < 3) {
      if (splitReading[1] && splitReading[1] === 'temp') {
        reading = splitReading[0] + '_' + splitReading[1];
      } else {
        reading = splitReading[0];
      }
    } else if (splitReading.length >= 3) {
      reading = splitReading[0] + '_' + splitReading[1];
    }
    return reading;
  };

  const getReadingStatus = (statusString) => _.indexOf(ReadingStatusStrings, statusString);

  const getStatusColor = (status) => {
    switch (status) {
      case ReadingStatus.NORMAL:
      case ReadingStatusStrings.Normal:
        return 'green';
      case ReadingStatus.NORMAL_LOW:
      case ReadingStatusStrings.LowNormal:
        return 'blueviolet';
      case ReadingStatus.NORMAL_HIGH:
      case ReadingStatusStrings.HighNormal:
        return 'goldenrod';
      case ReadingStatus.WARNING_LOW:
      case ReadingStatusStrings.LowWarn:
      case ReadingStatus.WARNING_HIGH:
      case ReadingStatusStrings.HighWarn:
        return 'darkorange';
      case ReadingStatus.CRITICAL_LOW:
      case ReadingStatusStrings.LowCrit:
      case ReadingStatus.CRITICAL_HIGH:
      case ReadingStatusStrings.HighCrit:
        return 'orangered';
      case ReadingStatus.ERROR:
      case ReadingStatusStrings.Error:
        return 'red';
      default:
        return '#919191';
    }
  };

  // This could be added to the Selectors
  const missingReadings = (telemetry, names) => {
    let missing = false;
    _.forEach(names, (name) => {
      if (_.has(readings, name)) {
        const reading = readings[name];
        if (reading.depths) {
          _.forEach(reading.depths, (depth) => {
            const path = getReadingPath(reading, depth);
            if (!_.has(telemetry, path)) {
              missing = true;
            }
          });
        } else {
          const path = getReadingPath(reading);
          if (!_.has(telemetry, path)) {
            missing = true;
          }
        }
      }
    });
    return missing;
  };

  const toFixed = (value, precision) => {
    const power = Math.pow(10, precision || 0); // eslint-disable-line
    return String(Math.round(value * power) / power);
  };

  const orderReadings = (readingsArray) => {
    return _.sortBy(readingsArray, (o) => {
      if (_.has(readings, o.Name)) {
        return readings[o.Name].order;
      }
      return 1000;
    });
  };

  const getReadingPath = (reading, depth) => {
    if (reading) {
      if (reading.basePath === 'raw') {
        let path = `raw.${reading.path}`;
        if (reading.depths) {
          path = `${path}_${depth}`;
        }
        return path;
      }
      if (reading.basePath === '') {
        return reading.path;
      }
      const depthString = depth !== undefined && reading.depths ? `[${depth}].` : '.';
      return reading.basePath + depthString + reading.path;
    }
    return false;
  };

  const displayReading = (name, value, error, units = false, convert = true, uncertainty = -1) => {
    let newValue = value;

    if (error) {
      return error;
    }

    if (value != 0 && value === undefined) {
      return 'Error';
    }
    if (_.isNaN(value)) {
      return '-';
    }
    if (_.has(readings, name)) {
      if (uncertainty > 0) {
        let floorValue = value - uncertainty;
        let ceilingValue = value + uncertainty;
        if (convert && _.has(readings[name], 'conversion')) {
          floorValue = readings[name].conversion(floorValue);
          ceilingValue = readings[name].conversion(ceilingValue);
        }
        if (_.has(readings[name], 'precision')) {
          floorValue = toFixed(floorValue, readings[name].precision);
          ceilingValue = toFixed(ceilingValue, readings[name].precision);
        }
        floorValue = floorValue >= 0 ? floorValue : 0;
        newValue = floorValue + ' - ' + ceilingValue;
      } else {
        if (convert && _.has(readings[name], 'conversion')) {
          newValue = readings[name].conversion(newValue);
        }
        if (_.has(readings[name], 'precision')) {
          newValue = toFixed(newValue, readings[name].precision);
        }
      }
    }
    if (uncertainty < 0 && (_.isNaN(newValue) || isNaN(newValue))) { // eslint-disable-line
      return '-';
    }

    if (units === true) {
      return `${newValue}${getUnits(name, '', convert)}`;
    }

    return newValue;
  };

  const unconvertReading = (name, value, convert = true) => {
    if (convert && _.has(readings[name], 'unconvert')) {
      return readings[name].unconvert(value);
    }
    return value;
  };

  const getUnits = (readingName, defaultUnits = '', convert = true) => {
    if (_.has(readings, readingName)) {
      if (convert && _.has(readings[readingName], 'convert_units')) {
        return readings[readingName].convert_units;
      }
      if (_.has(readings[readingName], 'units')) {
        return readings[readingName].units;
      }
    }
    return defaultUnits;
  };

  const roundReading = (name, value) => {
    let newValue = value;
    if (_.has(readings, name)) {
      if (_.has(readings[name], 'precision')) {
        newValue = toFixed(newValue, readings[name].precision);
      }
    }
    return newValue;
  };

  const isReadingType = (readingName) => {
    return _.has(readings, readingName);
  };

  const getUnitsForReading = (readingName, convert = true) => {
    if (_.has(readings, readingName)) {
      if (!convert && _.has(readings[readingName], 'units')) {
        return readings[readingName].units;
      } else if (convert && _.has(readings[readingName], 'convert_units')) {
        return readings[readingName].convert_units;
      } else {
        return undefined;
      }
    }
  };

  const getNeedsConversion = (readingName, convertPPM, convertTemp, convertUnits) => {
    if (Temps.includes(readingName) && convertUnits) {
      return true;
    } else if (NPK.includes(readingName?.toUpperCase()) && convertUnits) {
      return true;
    } else if (NPK.includes(readingName?.toUpperCase()) && convertPPM) {
      return true;
    } else if (Temps.includes(readingName) && convertTemp) {
      return true;
    } else if (readingName === 'moisture') {
      return true;
    }

    return false;
  };

  return {
    readings,
    depths,
    isReadingType,
    displayReading,
    getUnits,
    orderReadings,
    roundReading,
    unconvertReading,
    getReadingPath,
    toFixed,
    missingReadings,
    getReadingStatus,
    getStatusColor,
    getUnitsForReading,
    getNeedsConversion,
    getReadingDomain,
    getReadingName,
    ReadingStatusStrings,
  };
})();

export const TimePeriods = {
  EightHours: 8,
  ZeroDays: 0,
  OneDay: 1,
  TwoDays: 2,
  ThreeDays: 3,
  OneWeek: 7,
  OneMonth: 30,
  OneHourSeconds: 3600,
  ThreeHoursSeconds: 10800,
  ThreeMonth: 90,
  FourHoursSeconds: 14400,
  OneYear: 365,
  TwentyYears: 7300,
  EightHoursSeconds: 28800,
  OneDaySeconds: 86400,
  TwoDaysSeconds: 172800,
  ThreeDaysSeconds: 259200,
  OneWeekSeconds: 604800,
  OneMonthSeconds: 2592000,
  ThreeMonthSeconds: 7776000,
  OneYearSeconds: 31536000,
  TenYearSeconds: 315360000,
};

export const BucketPeriods = {
  Zero: 0,
  One: 1,
  Three: 3,
  Four: 4,
  Seven: 7,
  Eight: 8,
  Twelve: 12,
  Thirty: 30,
  ThreehundredSixtyFive: 365,
};

export const BucketUnits = {
  Days: 'days',
  Hours: 'hours',
  Minutes: 'minutes',
  Months: 'months',
  Years: 'years',
};

export const NPK = ['N', 'P', 'K'];
export const Temps = ['soil_temp', 'air_temp'];

export default ReadingsHelpers; // eslint-disable-line
